import { axiosAsocijator } from "../../axios/asocijator_axios";

export type TopicSearchParams = {
  skip?: number;
  limit?: number;
};

export type SetCharactersFromTextParams = {
  topicId: string;
};

export type TextRecognizePositionParams = {
  topicId: string;
  startPosition: number;
  deleteCount: number;
  add: string[];
};

export const setCharactersFromText = async ({
  topicId,
}: SetCharactersFromTextParams): Promise<string> => {
  let result: string = "";
  let response: any;
  try {
    response = await axiosAsocijator.put(
      `topic/input_way_text/${topicId}/set-characters-from-text`
    );
  } catch (error) {}
  if (response && response.status === 204) {
    result = response.data;
  }

  return result;
};

export const textRecognizePosition = async ({
  topicId,
  startPosition,
  deleteCount,
  add,
}: TextRecognizePositionParams): Promise<string> => {
  let result: string = "";
  let response: any;
  try {
    response = await axiosAsocijator.put(
      `topic/input_way_text/${topicId}/recognize-position`,
      { startPosition, deleteCount, add }
    );
  } catch (error) {}
  if (response && response.status === 204) {
    result = response.data;
  }

  return result;
};
